import * as actionType from "../actions/actionTypes";

const initState = { 
    userProfileLoading: false,
    userProfile: null,
    error : null
};

const initGetUserProfile = (state, action)=>{
    return {
        ...state,
        userProfile : action.userProfile
    }
};

const successGetUserProfile = (state, action)=>{
    return {
        ...state,
        userProfile : action.userProfile
    }
};

const failGetUserProfile = (state, action)=>{
    return {
        ...state,
        error : action.error
    }
};

const Reducer = (state=initState, action)=>{
    switch(action.type){
        case actionType.INIT_GET_USER_PROFILE : return initGetUserProfile(state, action);
        case actionType.SUCCESS_GET_USER_PROFILE : return successGetUserProfile(state, action);
        case actionType.FAIL_GET_USER_PROFILE : return failGetUserProfile(state, action);
        default : return {...state}
    }
};

export default Reducer;